module.exports = __webpack_public_path__ + "img/14.71d5a9fb.jpg";